import { intervalToDuration, formatDuration } from 'date-fns';
import { ptBR } from 'date-fns/locale';

/**
 * Returns a string in portuguese containing the difference of creation date and current date, prioritizing weeks and then days.
 * If more than four weeks ou less than a day, returns a fixed string
 * Example: Há 2 dias
 * Example: Há 3 semanas
 * Example: Há mais de um mês
 * Example: Há menos de um dia
 *
 * @param startDate {string | Date}
 * @param endDate {string | Date}
 *
 * @returns {string}
 */
export const getJobCustomTimeDurationString = (
  startDate: string | Date,
  endDate: string | Date
): string => {
  const duration = intervalToDuration({
    start: new Date(startDate),
    end: new Date(endDate),
  });

  if (duration.months || duration.years) return 'Há mais de um mês';
  if (!duration.days) return 'Há menos de um dia';

  let format = ['days'];

  // Add weeks
  if (duration.days && !duration.weeks) {
    duration.weeks = Math.floor(duration.days / 7);
    duration.days -= duration.weeks * 7;
  }

  if (duration.weeks) format = ['weeks'];

  const formatOptions = {
    format,
    locale: ptBR,
  };

  return `Há ${formatDuration(duration, formatOptions)}`;
};
